module.exports = __webpack_public_path__ + "static/media/boss-double-attack.a2bdd980.mp3";